import { Cookies as ReactCookies } from "react-cookie"
import { agent } from "./api.service"
const cookies = new ReactCookies()

export class AuthService {
  /**
   * @function login - Function to validate user credentials
   * @param email - username
   * @param password - user password
   * @returns response with authToken if valid user
   */
  static async login(email, password, isAdminLogin = false) {
    const endpoint = isAdminLogin ? process.env.VAL_SERVICE_ACCOUNT_USER : process.env.VAL_USER
    const url = `${process.env.HALLEN_API}${endpoint}`
    const payload = [
      {
        username: email,
        password: password,
        ...(isAdminLogin && { isTestUser: true }),
      },
    ]
    let response = {}
    await agent
      .post(url)
      .send(payload)
      .type("json")
      .set("Ocp-Apim-Subscription-Key", `${process.env.HALLEN_KEY}`)
      .then(res => {
        response = { ...res, data: res?.body }
      })
      .catch(error => {
        response = { ...error.response, data: error.response?.body }
      })
    return response
  }

  static async adLogin(adToken) {
    let url = `${process.env.HALLEN_API}${process.env.AD_LOGIN}`
    const urlDev = "https://hal-hoss2-qa-user-func-01-development.azurewebsites.net/api/ValAdUser?"
    if (process.env.USE_DEV === "true") {
      url = urlDev
    }
    const payload = [{ adToken }]
    let response = {}
    await agent
      .post(url)
      .send(payload)
      .type("json")
      .set("Accept", "application/json")
      .set("Ocp-Apim-Subscription-Key", `${process.env.HALLEN_KEY}`)
      .then(res => {
        response = { ...res, data: res?.body }
      })
      .catch(error => {
        response = { ...error.response, data: error.response?.body }
      })
    return response
  }

  static CookieUpdate(res) {
    if (res && res.status === 200 && res.data && res.data.authToken) {
      cookies.set("hallenToken", res.data.authToken, {
        maxAge: 3600,
        path: "/",
      })
    }
  }
}
